import React from "react";
import PropTypes from "prop-types";

const BaseButton = ({ children, className, type, disabled, onClick, forwardedRef, ...props }) => (
  <button
    className={className}
    disabled={disabled}
    type={type}
    onClick={onClick}
    ref={forwardedRef}
    {...props}
  >
    {children}
  </button>
);

BaseButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  children: PropTypes.node.isRequired,
  forwardedRef: PropTypes.oneOfType([
    PropTypes.shape({ current: PropTypes.instanceOf(<button />) }),
    PropTypes.func,
  ]),
};

BaseButton.defaultProps = {
  type: "button",
};

export default BaseButton;
